// src/routes/dashboard/components/KpiCard.tsx
import React from 'react';
import { Group, Stack, Text, ThemeIcon, Box } from '@mantine/core';
import { GinoriCard } from '../../../components/ui';

interface KpiCardProps {
  title: string;
  value: number | string;
  icon: React.ComponentType<{ size?: number; stroke?: number }>;
  color?: string;
  highlight?: boolean;
  onClick?: () => void;
  rightSection?: React.ReactNode;
}

export function KpiCard({ title, value, icon: Icon, color = 'blue', highlight = false, onClick, rightSection }: KpiCardProps) {
  return (
    <GinoriCard interactive={!!onClick}>
      <Box onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        <Group justify="space-between" align="center">
          <Stack gap={4}>
            <Text
              size="sm"
              fw={400}
              tt="uppercase"
              style={{
                fontFamily: '"Playfair Display", serif',
                letterSpacing: '0.8px',
                color: 'var(--ginori-text-muted)',
              }}
            >
              {title}
            </Text>
            <Text
              fw={400}
              size="xl"
              style={{
                fontFamily: '"Playfair Display", serif',
                color: highlight ? `var(--mantine-color-${color}-7)` : 'var(--ginori-text-primary)',
                fontSize: '1.75rem',
              }}
            >
              {value}
            </Text>
          </Stack>

          <Box>
            <ThemeIcon color={color} variant="light" radius="sm" size="lg">
              <Icon size={22} stroke={1.5} />
            </ThemeIcon>
          </Box>
        </Group>

        {rightSection && <Box mt="sm">{rightSection}</Box>}
      </Box>
    </GinoriCard>
  );
}
